import {ImageProcessingNodes} from "@cm/image-processing-nodes"
import {Descriptor} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {ImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc"
import {TypedImageData} from "@cm/utils"
import {Size2Like} from "@cm/math"

export const createImageOpImgProc = (descriptor: Descriptor, node: ImageProcessingNodes.ImageNode) => {
    return new ImageOpImgProc(descriptor, node)
}

// the decoded data object may not match the requested descriptor (e.g. an upstream operator changed output size after it was authored) -
// crop/zero-extend at the origin to fit rather than resampling, so retained content stays pixel-aligned. no-op if the sizes already match.
export const cropOrZeroExtendImageOpImgProc = (
    image: ImageOpImgProc,
    nativeSize: Size2Like,
    descriptor: Descriptor,
    createEmptyImage: (descriptor: Descriptor) => ImageOpImgProc,
): ImageOpImgProc => {
    if (nativeSize.width === descriptor.width && nativeSize.height === descriptor.height) {
        return image
    }
    const emptyImage = createEmptyImage(descriptor)
    return createImageOpImgProc(descriptor, {
        type: "copyRegion",
        source: image.node,
        sourceRegion: {type: "region", region: [0, 0, Math.min(nativeSize.width, descriptor.width), Math.min(nativeSize.height, descriptor.height)]},
        target: emptyImage.node,
        targetOffset: {type: "offset", offset: [0, 0]},
    })
}

export const isImageOpImgProc = (obj: unknown): obj is ImageOpImgProc => {
    return obj instanceof ImageOpImgProc
}

export const getImgProcChannelLayoutByCount = (numChannels: number): TypedImageData["channelLayout"] => {
    switch (numChannels) {
        case 1:
            return "L"
        case 3:
            return "RGB"
        case 4:
            return "RGBA"
        default:
            throw new Error(`Invalid channel count: ${numChannels}`)
    }
}
